/* eslint-disable react/jsx-no-bind */
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { FC, useLayoutEffect, useState } from "react";

import {
  MODULE_MODAL_CONTENT_Z_INDEX,
  MODULE_MODAL_OVERLAY_Z_INDEX,
} from "./moduleModalStacking";
import {
  DistributionGroupOption,
  UserTagModuleLinkFields,
} from "./UserTagModuleLinkFields";

type Props = {
  isOpen: boolean;
  moduleName: string;
  onClose: () => void;
  onSubmit: (
    popupGroupIds: string[],
    abtestScenarioPageGroupIds: string[]
  ) => void | Promise<void>;
  popupGroupOptions: DistributionGroupOption[];
  abtestGroupOptions: DistributionGroupOption[];
  initialPopupGroupIds: string[];
  initialAbtestScenarioPageGroupIds: string[];
  isLoading?: boolean;
};

export const ModuleLinkModal: FC<Props> = ({
  isOpen,
  moduleName,
  onClose,
  onSubmit,
  popupGroupOptions,
  abtestGroupOptions,
  initialPopupGroupIds,
  initialAbtestScenarioPageGroupIds,
  isLoading = false,
}) => {
  const [selectedPopupGroupIds, setSelectedPopupGroupIds] = useState<string[]>(
    []
  );
  const [selectedAbtestGroupIds, setSelectedAbtestGroupIds] = useState<
    string[]
  >([]);

  useLayoutEffect(() => {
    if (!isOpen) return;
    setSelectedPopupGroupIds(initialPopupGroupIds);
    setSelectedAbtestGroupIds(initialAbtestScenarioPageGroupIds);
  }, [initialAbtestScenarioPageGroupIds, initialPopupGroupIds, isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = () => {
    void onSubmit(selectedPopupGroupIds, selectedAbtestGroupIds);
  };

  return (
    <Modal isOpen onClose={onClose} size="lg" scrollBehavior="inside">
      <ModalOverlay zIndex={MODULE_MODAL_OVERLAY_Z_INDEX} />
      <ModalContent
        containerProps={{
          zIndex: MODULE_MODAL_CONTENT_Z_INDEX,
        }}
      >
        <ModalHeader>
          <Text fontWeight="semibold">ポップアップ・ABテストのリンク</Text>
          <Text fontSize="sm" fontWeight="normal" color="gray.600" mt={1}>
            {moduleName}
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <UserTagModuleLinkFields
            popupGroupOptions={popupGroupOptions}
            abtestGroupOptions={abtestGroupOptions}
            selectedPopupGroupIds={selectedPopupGroupIds}
            selectedAbtestGroupIds={selectedAbtestGroupIds}
            onPopupGroupIdsChange={setSelectedPopupGroupIds}
            onAbtestGroupIdsChange={setSelectedAbtestGroupIds}
            disabled={isLoading}
          />
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button variant="ghost" onClick={onClose} isDisabled={isLoading}>
              キャンセル
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSubmit}
              isLoading={isLoading}
            >
              保存
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
